import React, { useState, ReactNode } from 'react';
import { section } from '../../types/types';
import { Card, Col, Divider, Flex, Popover, Row, Typography } from 'antd';
import { CloseCircleOutlined, PushpinFilled, PushpinOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import styles from "./infoCard.module.scss";
import { useTranslation } from 'react-i18next';
import InfoCardRecord from "./recordComponent";
interface Props {
  urlparams: Map<string, string>;
  section: section;
  showEmpty?: boolean;
  header?: string;
  apiError?: string;
  sectionFieldValues?: [any],
  pinned: Function,
  enablePin: boolean,
  breakGrid ?: boolean
}

const { Text } = Typography

const InfoCard: React.FC<Props> = ({
  urlparams,
  section,
  showEmpty = true,
  sectionFieldValues,
  apiError,
  pinned,
  enablePin = true,
  breakGrid = false
}) => {



  const { t } = useTranslation();
  let actualApi = section.api;

  urlparams.forEach((value, key) => {
    actualApi = actualApi?.replace("{" + key + "}", value);
  });

  // const [loading, setLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [content, setContent] = useState<ReactNode>(<></>);

  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };


  const computFieldValueUsingExpr = (field: any, formula: string): any => {
    return eval(formula).replace(/null/g, '');
  }


  if (errorMessage) {
    <div> Something went wrong: {errorMessage} </div>
  } else if (sectionFieldValues?.length || apiError) {

    const generateContent = () => {
      return (
        <div className='my-2'>
          <Flex justify="space-between">
            <div>
              <Text className={"mb-2 mr-2 text-lg font-semibold text-secondary " + styles.label} color={section.template?.headingColor}>  {t(section.sectionName)} </Text>
            </div>
            <div>
              <a onClick={hide}>
                <CloseCircleOutlined rev={undefined} />
              </a>
            </div>
          </Flex>

          <Divider className='my-2' />
          <div style={{ maxHeight: "640px" }} className='p-2 mt-2'>
            {sectionFieldValues?.map((values, index) => {

              return (

                <div>
                  {index !== 0 && <Divider></Divider>}
                  <Row>
                    {section.viewForm && section.viewForm?.map((key, index) => {
                      // console.count("viewForm");

                      if (key.type === 'COMPUTED') {
                        return (

                          <Col span={8}>
                            <InfoCardRecord key={index} template={section.template} viewForm={key} value={computFieldValueUsingExpr(values, key.evalFormula ?? "")}></InfoCardRecord>
                          </Col>


                        )
                      }

                      if (showEmpty || values[key.field]) {
                        return (
                          <Col span={8}>
                            <InfoCardRecord key={index} template={section.template} viewForm={key} value={values[key.field]}></InfoCardRecord>
                          </Col>

                        )
                      } else {
                        return <Col span={12}></Col>
                      }

                    }

                    )}

                    {section.subsections && section.subsections.map((section, index) =>

                      section.viewForm && section.viewForm?.map((key) => {

                        if (key.type === 'COMPUTED') {
                          return (
                            <Col span={8}>
                              <InfoCardRecord key={index} template={section.template} viewForm={key} value={computFieldValueUsingExpr(values, key.evalFormula ?? "")}></InfoCardRecord>
                            </Col>
                          )
                        }
                        if (showEmpty || values[key.field]) {
                          return (
                            <Col span={8}>
                              <InfoCardRecord template={section.template} viewForm={key} value={values[key.field]}></InfoCardRecord>
                            </Col>
                          )
                        } else {
                          return <Col span={12}></Col>
                        }
                      }
                      )
                    )}
                  </Row>
                </div>
              )
            })
            }
          </div>
        </div>

      )
    };

    const handlePopOverContent = (): ReactNode => {
      return generateContent();
    }

    const handleOpenChange = (newOpen: boolean) => {

      if (section.popOverBoard === false || apiError) {
        setOpen(false);
        return;
      } else {
        setOpen(newOpen);

        setContent(handlePopOverContent());
      }


    };

    return (

      <>
        <Popover trigger="click" placement="left" open={open} styles={{
          body: {
            maxWidth: "600px",
            overflow: "scroll"
          }
        }}
          onOpenChange={handleOpenChange} destroyTooltipOnHide={true} content={(section.popOverBoard === false || apiError) ? "" : (content || <div className='text-center p-4'> Loading... </div>)} showArrow={true} >
          <Card styles={{
            body: {
              padding: '0.5rem', // Adjust the padding as needed
            },
            header: {
              minHeight: "42px",
              padding: "0.5rem"
            }
          }} style={{ boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)", padding: 0 }} className='my-2 info-card' title={
            <Flex justify="space-between">
              <div>
                <Text className={"text-sm font-semibold " + styles.label} color={section.template?.headingColor} >  {t(section.sectionName)} </Text>
              </div>

              {enablePin && <div onClick={(ev) => { ev.stopPropagation(); pinned() }}> {section.isPinned ? <PushpinFilled className='text-primary mr-2' rev={undefined} /> : <PushpinOutlined className='mr-2' rev={undefined} />} </div>}

              {apiError ? (<div className={styles.iconContaier}>
                <FontAwesomeIcon icon={faExclamationTriangle} className={"fa " + styles.faExclamationTriangleStyle} title='Something  went wrong, please check with your admin.' />
              </div>) : (<></>)}
            </Flex>}>

            <div>
              <Row className='w-100'>

                {sectionFieldValues?.map((values, index) => {
                  // console.count("field vals");
                  return (
                    <>
                      {index !== 0 && <Divider></Divider>}
                      <Row key={index} className='my-2 w-100'>
                        <>

                          {section.viewForm && section.viewForm.filter((item) => { return item.mainCardBoard }).map((key, index) => {

                            if (key.type === 'COMPUTED') {
                              return (
                                <Col span={breakGrid ? 6 : 12}>
                                  <InfoCardRecord key={index} template={section.template} viewForm={key} value={computFieldValueUsingExpr(values, key.evalFormula ?? "")}></InfoCardRecord>
                                </Col>


                              )
                            }
                            else if (showEmpty || values[key.field]) {
                              return (
                                <Col span={breakGrid ? 6 : 12}>
                                  <InfoCardRecord key={index} template={section.template} viewForm={key} value={values[key.field]}></InfoCardRecord>
                                </Col>

                              )
                            }
                          }
                          )}

                          {section.subsections && section.subsections.map((section, index) =>
                            section.viewForm && section.viewForm?.filter((item) => { return item.mainCardBoard }).map((key) => {

                              if (key.type === 'COMPUTED') {
                                return (
                                  <Col span={breakGrid ? 6 : 12}>
                                    <InfoCardRecord key={index} template={section.template} viewForm={key} value={computFieldValueUsingExpr(values, key.evalFormula ?? "")}></InfoCardRecord>
                                  </Col>
                                )
                              }
                              else if (showEmpty || values[key.field]) {
                                return (
                                  <Col span={breakGrid ? 6 : 12}>
                                    <InfoCardRecord template={section.template} viewForm={key} value={values[key.field]}></InfoCardRecord>
                                  </Col>
                                )
                              }
                            })
                          )}

                        </>
                      </Row>
                    </>


                  )
                })
                }
              </Row>
            </div>
          </Card>
        </Popover>
      </>
    );
  }

  return (<></>)

};

export default React.memo(InfoCard);
